module.exports = __webpack_public_path__ + "images/emoji/skull.b8a6687f0606175f3ca5.png";